"use client";

import { useState } from 'react';
import DashboardSidebar from '../dashboard/DashboardSidebar';
import RepositoryDetail from '../sections/RepositoryDetail';
import ArchitectureDiagram from '../visualization/ArchitectureDiagram';

export default function DashboardLayout({ children, user, selectedProjectId }) {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedRepository, setSelectedRepository] = useState(null);

  const handleRepositorySelect = (repoId) => {
    setSelectedRepository(repoId);
  };

  return (
    <div className="min-h-screen bg-[#F6F8FA] dark:bg-gray-900">
      <div className="flex h-screen">
        <DashboardSidebar 
          user={user}
          selectedProjectId={selectedProjectId}
          selectedRepositoryId={selectedRepository}
          onRepositorySelect={handleRepositorySelect}
          collapsed={collapsed}
          onCollapse={() => setCollapsed(!collapsed)}
        />
        
        {/* Main content */}
        <div className="flex-1 overflow-auto bg-[#F6F8FA] dark:bg-gray-900 p-6">
          <div className="h-full">
            {selectedRepository ? (
              <RepositoryDetail repositoryId={selectedRepository} user={user} />
            ) : (
              children
            )}
          </div>
        </div>
      </div>
    </div>
  );
} 